if (!customElements.get('pino-product-facts')) {
  let nextFactsId = 0;
  customElements.define('pino-product-facts', class extends HTMLElement {
    connectedCallback() {
      if (!this.initialized && !this.initialize()) return;
      if (!this.secondaryRows.length) return;
      this.button.addEventListener('click', this.toggle);
      this.mobile.addEventListener('change', this.render);
      this.render();
    }

    initialize() {
      this.button = this.querySelector('[data-pino-facts-toggle]');
      this.label = this.button?.querySelector('[data-pino-facts-label]');
      this.symbol = this.button?.querySelector('[data-pino-facts-symbol]');
      if (!this.button || !this.label || !this.symbol) return false;
      this.secondaryRows = Array.from(this.querySelectorAll('.pino-piece-facts > [data-pino-fact-secondary]'));
      this.initialized = true;
      if (!this.secondaryRows.length) return true;
      const factsId = `PinoProductFacts-${++nextFactsId}`;
      this.secondaryRows.forEach((row, index) => {
        if (!row.id) row.id = `${factsId}-${index + 1}`;
      });
      this.button.setAttribute('aria-controls', this.secondaryRows.map((row) => row.id).join(' '));
      this.expanded = false;
      this.mobile = window.matchMedia('(max-width: 639px)');
      this.render = () => {
        const collapsed = this.mobile.matches && !this.expanded;
        if (collapsed && this.secondaryRows.some((row) => row.contains(document.activeElement))) {
          this.button.focus({ preventScroll: true });
        }
        this.secondaryRows.forEach((row) => { row.hidden = collapsed; });
        this.button.hidden = !this.mobile.matches;
        this.button.setAttribute('aria-expanded', String(!collapsed));
        this.label.textContent = collapsed ? this.button.dataset.readMore : this.button.dataset.readLess;
        this.symbol.textContent = collapsed ? '+' : '−';
      };
      this.toggle = () => {
        this.expanded = !this.expanded;
        this.render();
      };
      return true;
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.toggle);
      this.mobile?.removeEventListener('change', this.render);
    }
  });
}
